import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "Is my consultation private and secure?",
      answer: "Absolutely. We adhere to strict HIPAA and GDPR compliance standards. Your video consultation is end-to-end encrypted, and your medical records are stored on secure, private servers accessible only to you and your doctor."
    },
    {
      question: "Do you accept health insurance?",
      answer: "We partner with major insurance providers across Africa. You can add your insurance details within the app to check coverage eligibility before booking. We also offer affordable out-of-pocket pricing."
    },
    {
      question: "How does medication delivery work?",
      answer: "Once prescribed, our partner pharmacies prepare your medication. It is packaged in discreet, unmarked boxes to ensure privacy and delivered to your preferred address via our courier partners within 24-48 hours."
    },
    {
      question: "Are the doctors qualified?",
      answer: "Yes, every specialist on the MHC Africa platform is a board-certified practitioner verified by the medical board. You can view their credentials, experience, and patient reviews directly in the app."
    },
    {
      question: "Can I get a refund if I cancel?",
      answer: "You can cancel or reschedule an appointment up to 4 hours before the scheduled time for a full refund. Missed appointments may be subject to a small cancellation fee."
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-secondary mb-4">
            Frequently Asked <span className="text-primary">Questions</span>
          </h2>
          <p className="text-gray-600">
            Got questions? We've got answers. If you need more help, our support team is available 24/7 in the app.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`bg-white rounded-2xl border transition-all duration-300 ${openIndex === index ? 'border-primary/30 shadow-lg shadow-primary/5' : 'border-gray-200 hover:border-primary/30'}`}
            >
              <button
                className="w-full flex items-center justify-between p-6 text-left"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className={`font-bold text-lg ${openIndex === index ? 'text-primary' : 'text-secondary'}`}>
                  {faq.question}
                </span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === index ? 'bg-primary text-white' : 'bg-gray-100 text-gray-500'}`}>
                  {openIndex === index ? <Minus size={16} /> : <Plus size={16} />}
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="p-6 pt-0 text-gray-600 leading-relaxed border-t border-dashed border-gray-100 mt-2">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};